/* eslint-disable */
// Request Leave — two self-contained components, no existing code touched.
//   Parent:  <LeaveRequestParent studentId={student?.id} studentName={student?.name||student?.full_name} parentEmail={session?.user?.email}/>
//   Admin:   <LeaveRequestAdmin/>
// Requires the leave_requests table (see SQL in chat).
import React from "react";
import { supabase } from "./supabaseClient";

const STATUS = {
  pending:  { label: "Pending",  bg: "#fffbeb", fg: "#d97706", bd: "#fde68a" },
  approved: { label: "Approved", bg: "#f0fdf4", fg: "#16a34a", bd: "#bbf7d0" },
  rejected: { label: "Rejected", bg: "#fef2f2", fg: "#dc2626", bd: "#fecaca" },
};
const Badge = ({ s }) => {
  const c = STATUS[s] || STATUS.pending;
  return <span style={{ background: c.bg, color: c.fg, border: `1px solid ${c.bd}`, borderRadius: 8, padding: "2px 10px", fontSize: 12, fontWeight: 700 }}>{c.label}</span>;
};
const fmt = d => d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—";

export function LeaveRequestParent({ studentId, studentName, parentEmail }) {
  const [form, setForm] = React.useState({ from_date: "", to_date: "", reason: "" });
  const [rows, setRows] = React.useState([]);
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg]   = React.useState(null);

  const load = React.useCallback(async () => {
    if (!parentEmail) return;
    const { data } = await supabase.from("leave_requests").select("*").eq("parent_email", parentEmail).order("created_at", { ascending: false });
    setRows(data || []);
  }, [parentEmail]);
  React.useEffect(() => { load(); }, [load]);

  const submit = async () => {
    if (!form.from_date || !form.to_date) return setMsg({ ok: false, t: "Pick both dates." });
    if (form.to_date < form.from_date)   return setMsg({ ok: false, t: "End date is before start date." });
    setBusy(true);
    const { error } = await supabase.from("leave_requests").insert({
      student_id: String(studentId || ""), student_name: studentName || "", parent_email: parentEmail || "",
      from_date: form.from_date, to_date: form.to_date, reason: form.reason || "", status: "pending",
    });
    setBusy(false);
    if (error) return setMsg({ ok: false, t: error.message });
    setMsg({ ok: true, t: "Request submitted." });
    setForm({ from_date: "", to_date: "", reason: "" });
    load();
  };

  const inp = { width: "100%", padding: "8px 10px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 13, boxSizing: "border-box" };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, padding: "16px 18px" }}>
        <div style={{ fontWeight: 800, fontSize: 15, color: "#1a6b3c", marginBottom: 12 }}>📝 Request Leave</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
          <div><label style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>From</label>
            <input type="date" value={form.from_date} onChange={e => setForm(p => ({ ...p, from_date: e.target.value }))} style={inp} /></div>
          <div><label style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>To</label>
            <input type="date" value={form.to_date} onChange={e => setForm(p => ({ ...p, to_date: e.target.value }))} style={inp} /></div>
        </div>
        <label style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>Reason</label>
        <textarea rows={2} value={form.reason} onChange={e => setForm(p => ({ ...p, reason: e.target.value }))} placeholder="e.g. family travel, medical…" style={{ ...inp, resize: "vertical", marginBottom: 10 }} />
        {msg && <div style={{ fontSize: 12, color: msg.ok ? "#16a34a" : "#dc2626", marginBottom: 8 }}>{msg.t}</div>}
        <button onClick={submit} disabled={busy} style={{ width: "100%", background: busy ? "#9ca3af" : "#1a6b3c", color: "#fff", border: "none", borderRadius: 9, padding: 10, fontWeight: 700, fontSize: 13, cursor: busy ? "default" : "pointer" }}>{busy ? "Submitting…" : "Submit Request"}</button>
      </div>

      {rows.length > 0 && (
        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, padding: "14px 16px" }}>
          <div style={{ fontWeight: 700, fontSize: 13, color: "#374151", marginBottom: 10 }}>Your requests</div>
          {rows.map(r => (
            <div key={r.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderTop: "1px solid #f3f4f6" }}>
              <div><div style={{ fontSize: 13, fontWeight: 700 }}>{fmt(r.from_date)} → {fmt(r.to_date)}</div>
                <div style={{ fontSize: 11, color: "#9ca3af" }}>{r.reason || "—"}{r.admin_note ? ` · note: ${r.admin_note}` : ""}</div></div>
              <Badge s={r.status} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function LeaveRequestAdmin({ scopeStudentIds = null } = {}) {
  const [rows, setRows]     = React.useState([]);
  const [filter, setFilter] = React.useState("pending");
  const [loading, setLoad]  = React.useState(true);
  const [error, setError]   = React.useState(null);
  const [me, setMe]         = React.useState("");

  const load = React.useCallback(async () => {
    try {
      setLoad(true); setError(null);
      const { data: { user } } = await supabase.auth.getUser();
      setMe(user?.email || "admin");
      const { data, error } = await supabase.from("leave_requests").select("*").order("created_at", { ascending: false });
      if (error) throw error;
      setRows(data || []);
    } catch (e) { setError(e.message || String(e)); } finally { setLoad(false); }
  }, []);
  React.useEffect(() => { load(); }, [load]);

  const markAttendanceLeave = async (r) => {
  const dates = [];
  let d = new Date(r.from_date);
  const end = new Date(r.to_date);

  for (; d <= end; d.setDate(d.getDate() + 1)) {
    dates.push(new Date(d).toISOString().slice(0, 10));
  }

  const sid = String(
    isNaN(Number(r.student_id)) ? (r.student_id || "") : Number(r.student_id)
  );

  let cls = "";
  let name = r.student_name || "";

  try {
    const { data: stu } = await supabase
      .from("students")
      .select("class, full_name")
      .eq("id", sid)
      .maybeSingle();

    if (stu) {
      cls = stu.class || "";
      name = stu.full_name || name;
    }
  } catch (e) {}

  const { error: delErr } = await supabase
    .from("attendance")
    .delete()
    .in("date", dates)
    .eq("student_id", sid);

  if (delErr) return { error: delErr };

  const rows = dates.map((date) => ({
    date,
    student_id: sid,
    student_name: name,
    class: cls,
    status: "LV",
    statuscode: "LV",
    statuslabel: "Leave",
    note: r.reason || "Approved leave request",
    latetime: null,
  }));

  return await supabase
    .from("attendance")
    .insert(rows);
};

 const decide = async (r, status) => {
  if (status === "approved") {
    const days =
      Math.round((new Date(r.to_date) - new Date(r.from_date)) / 864e5) + 1;

    if (
      !window.confirm(
        `Approve and mark ${days} day(s) as Leave on the attendance register? Existing attendance on those dates will be replaced.`
      )
    ) {
      return;
    }
  }

  const note =
    status === "rejected"
      ? (window.prompt("Optional note for parent:") || "")
      : "";

  const { error } = await supabase
    .from("leave_requests")
    .update({
      status,
      admin_note: note,
      decided_at: new Date().toISOString(),
      decided_by: me,
    })
    .eq("id", r.id);

  if (error) {
    return alert("Could not update: " + error.message);
  }

  if (status === "approved") {
    const { error: attErr } = await markAttendanceLeave(r);

    if (attErr) {
      return alert(
        "Leave was approved, but attendance could not be marked: " +
          attErr.message
      );
    }
  }

  setRows((p) =>
    p.map((x) =>
      x.id === r.id ? { ...x, status, admin_note: note } : x
    )
  );
};

  const scopeSet = scopeStudentIds ? new Set(scopeStudentIds.map(String)) : null;
  const scoped = scopeSet ? rows.filter(r => scopeSet.has(String(r.student_id))) : rows;
  const shown = scoped.filter(r => filter === "all" ? true : r.status === filter);
  const pendingCount = scoped.filter(r => r.status === "pending").length;

  return (
    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, padding: "16px 18px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
        <div style={{ fontWeight: 800, fontSize: 16, color: "#1a6b3c" }}>📝 Leave Requests {pendingCount > 0 && <span style={{ background: "#d97706", color: "#fff", borderRadius: 20, padding: "1px 9px", fontSize: 12 }}>{pendingCount}</span>}</div>
        <div style={{ display: "flex", gap: 6 }}>
          {["pending", "all"].map(f => (
            <button key={f} onClick={() => setFilter(f)} style={{ background: filter === f ? "#1a6b3c" : "#fff", color: filter === f ? "#fff" : "#374151", border: "1px solid #d1d5db", borderRadius: 8, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>{f === "pending" ? "Pending" : "All"}</button>
          ))}
        </div>
      </div>

      {loading && <div style={{ color: "#9ca3af", fontSize: 13 }}>Loading…</div>}
      {error && <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "10px 12px", color: "#b91c1c", fontSize: 13 }}>⚠ {error}<br /><span style={{ fontSize: 12 }}>Likely the leave_requests table is missing or RLS is blocking reads.</span></div>}
      {!loading && !error && shown.length === 0 && <div style={{ color: "#6b7280", fontSize: 13 }}>No {filter === "pending" ? "pending" : ""} requests.</div>}

      {shown.map(r => (
        <div key={r.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, padding: "10px 0", borderTop: "1px solid #f3f4f6", flexWrap: "wrap" }}>
          <div style={{ minWidth: 180 }}>
            <div style={{ fontSize: 14, fontWeight: 800 }}>{r.student_name || "—"}</div>
            <div style={{ fontSize: 12, color: "#374151" }}>{fmt(r.from_date)} → {fmt(r.to_date)}</div>
            <div style={{ fontSize: 11, color: "#9ca3af" }}>{r.reason || "—"}</div>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {r.status === "pending" ? (
              <>
                <button onClick={() => decide(r, "approved")} style={{ background: "#f0fdf4", color: "#16a34a", border: "1px solid #bbf7d0", borderRadius: 8, padding: "6px 14px", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>Approve</button>
                <button onClick={() => decide(r, "rejected")} style={{ background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 8, padding: "6px 14px", fontWeight: 700, fontSize: 12, cursor: "pointer" }}>Reject</button>
              </>
            ) : <Badge s={r.status} />}
          </div>
        </div>
      ))}
    </div>
  );
}
